import React, { useEffect, useRef, useState } from 'react';

import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';

import clsx from 'clsx';

import { useStyles } from './Style';

export const formatarTempo = segundos => {
    const total = Math.max(0, Math.floor(segundos || 0));
    const minutos = String(Math.floor(total / 60)).padStart(2, '0');
    const resto = String(total % 60).padStart(2, '0');

    return `${minutos}:${resto}`;
};

const ContadorReserva = ({ seconds, onExpire, warningAt = 60, total, paused = false }) => {
    const classes = useStyles();

    const [restantes, setRestantes] = useState(() => Math.max(0, Math.floor(seconds || 0)));
    const onExpireRef = useRef(onExpire);
    const expiradoRef = useRef(false);

    useEffect(() => {
        onExpireRef.current = onExpire;
    }, [onExpire]);

    useEffect(() => {
        expiradoRef.current = false;
        setRestantes(Math.max(0, Math.floor(seconds || 0)));
    }, [seconds]);

    useEffect(() => {
        if (seconds == null || seconds <= 0) return;
        if (paused) return;

        if (restantes <= 0) {
            if (!expiradoRef.current) {
                expiradoRef.current = true;
                if (onExpireRef.current) onExpireRef.current();
            }
            return;
        }

        const timer = setTimeout(() => setRestantes(anterior => Math.max(0, anterior - 1)), 1000);

        return () => clearTimeout(timer);
    }, [restantes, paused, seconds]);

    const aviso = restantes > 0 && restantes <= warningAt;
    const base = total && total > 0 ? total : Math.max(restantes, 1);
    const progresso = Math.min(100, (restantes / base) * 100);

    return (
        <div className={clsx(classes.contador, { [classes.contadorAviso]: aviso })}>
            <div className={classes.contadorLinha}>
                <Typography variant="caption" color="inherit">Tempo de Reserva do Cartão</Typography>
                <Typography variant="subtitle2" color="inherit">{formatarTempo(restantes)}</Typography>
            </div>

            <LinearProgress
                variant="determinate"
                value={progresso}
                color={aviso ? 'secondary' : 'primary'}
            />
        </div>
    );
};

export default ContadorReserva;
